import posthog from 'posthog-js';

const API_KEY = process.env.REACT_APP_POSTHOG_API_KEY || '';
const HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

let initialized = false;

export function initPostHog() {
  if (initialized || !API_KEY) return false;
  posthog.init(API_KEY, {
    api_host: HOST,
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    loaded: (ph) => {
      if (process.env.NODE_ENV === 'development') {
        // Keep quiet in prod; useful when verifying local events
        ph.debug(false);
      }
    },
  });
  initialized = true;
  return true;
}

export function track(event, properties = {}) {
  if (!API_KEY) return;
  if (!initialized) initPostHog();
  try {
    posthog.capture(event, properties);
  } catch {
    /* ignore analytics failures */
  }
}

export function identifyUser(user) {
  if (!API_KEY || !user?.email) return;
  if (!initialized) initPostHog();
  try {
    posthog.identify(String(user.id || user.email), {
      email: user.email,
      name: user.name || undefined,
      company: user.company_name || user.company || undefined,
    });
  } catch {
    /* ignore */
  }
}

export default posthog;
